// This code depends on Intl, polyfill must be included if browser need it (IE < 11 & Android browser).
// This code depends on IntlMessageFormat, polyfill must be included for all browsers for now.
// Also, it might be a good idea to include Intl & intl-messageformat locale date for the user locale.
// Include the right scripts into your HTML accordingly.

export class MessageFormatter {
    constructor({logger = console} = {}) {
        this._logger = logger;
    }

    formatBasicMessage(message, ...args) {
        let msg = message.replace(/''/g, "'");

        if (args.length === 1 && Array.isArray(args[0])) {
            args = args[0];
        }

        args.forEach((arg, idx) => {
            msg = msg.replace(new RegExp('\\{' + idx + '}', 'g'), arg);
        });

        return msg;
    }

    formatIcuMessage(message, argHash, locale) {
        // eslint-disable-next-line no-undef
        const mf = new IntlMessageFormat(message, locale);
        try {
            return mf.format(argHash || {});
        } catch (e) {
            this._logger.error(e);
            return message;
        }
    }
}
